module.exports = __webpack_public_path__ + "img/SIDEBAR_Persönliche_Daten.d1de5322.svg";